import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { FaHome, FaBox, FaShoppingCart, FaUser, FaGlobe } from 'react-icons/fa';

const MobileNavigation = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { currentLanguage, changeLanguage } = useLanguage();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const toggleLanguage = () => {
    const newLang = currentLanguage === 'en' ? 'ar' : 'en';
    changeLanguage(newLang);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#18100d]/90 backdrop-blur-md border-t border-cigar-brown/40 px-2 py-1 safe-bottom">
      <div className="flex justify-around items-center max-w-lg mx-auto">
        <Link 
          to="/" 
          className={`flex flex-col items-center p-2 relative ${isActive('/') ? 'text-cigar-gold after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-1 after:h-1 after:bg-cigar-gold after:rounded-full' : 'text-cigar-cream'}`}
        >
          <FaHome className="text-xl mb-1" />
          <span className="text-xs">{t('navbar.home')}</span>
        </Link>
        <Link 
          to="/products" 
          className={`flex flex-col items-center p-2 ${isActive('/products') ? 'text-cigar-gold' : 'text-cigar-cream'}`}
        >
          <FaBox className="text-xl mb-1" />
          <span className="text-xs">{t('navbar.products')}</span>
        </Link>
        <Link 
          to="/cart" 
          className={`flex flex-col items-center p-2 ${isActive('/cart') ? 'text-cigar-gold' : 'text-cigar-cream'}`}
        >
          <FaShoppingCart className="text-xl mb-1" />
          <span className="text-xs">{t('navbar.cart')}</span>
        </Link>
        <Link 
          to={user ? '/profile' : '/login'} 
          className={`flex flex-col items-center p-2 ${isActive(user ? '/profile' : '/login') ? 'text-cigar-gold' : 'text-cigar-cream'}`}
        >
          <FaUser className="text-xl mb-1" />
          <span className="text-xs">{user ? t('navbar.profile') : t('navbar.login')}</span>
        </Link>
        <button 
          onClick={toggleLanguage}
          className="flex flex-col items-center p-2 text-cigar-cream"
        >
          <FaGlobe className="text-xl mb-1" />
          <span className="text-xs">{currentLanguage.toUpperCase()}</span>
        </button>
      </div>
    </div>
  );
};

export default MobileNavigation;